import { DatePipe } from "@angular/common";
import { AttributeTypes, AttributeValues, QueryOperators } from "../../documents/models/DocumentFilterAttribute";

export class AttributeFilterDto {
    attributeId:string;
    field:string;
    operator?:string;
    typeCode?:string;
    min?:any;
    max?:any;
    value?:any;
    displayValue: any;

    public static CreateReferenceAttribute(attributeId: string, value: string = null, displayValue = null): AttributeFilterDto {

        let ret: AttributeFilterDto = null;
        if (value) {
            ret = new AttributeFilterDto();
            ret.attributeId = attributeId;
            ret.operator = QueryOperators.Eq;
            ret.typeCode = AttributeTypes.Reference;
            ret.field = AttributeValues.asReference;
            ret.value = value;
            ret.displayValue = displayValue;
        }
        return ret;
    }
    public static CreateStringAttribute(attributeId: string, operator: string = QueryOperators.In, value: string = null, min: string = null, max: string = null): AttributeFilterDto {

        let ret: AttributeFilterDto = null;
        if (value || min || max) {
            ret = new AttributeFilterDto();
            ret.attributeId = attributeId;
            ret.operator = operator,
            ret.typeCode = AttributeTypes.String,
            ret.field = AttributeValues.asShortString,
            ret.value = value,
            ret.min = min,
            ret.max = max
        }
        return ret;
    }
    public static CreateDateAttribute(attributeId: string, operator: string = QueryOperators.In, value: string = null, min: string = null, max: string = null): AttributeFilterDto {

        let ret: AttributeFilterDto = null;
        if (value || min || max) {
            ret = new AttributeFilterDto();
            ret.attributeId = attributeId;
            ret.operator = operator,
            ret.typeCode = AttributeTypes.Date,
            ret.field = AttributeValues.asDate,
            ret.value = value,
            ret.min = min,
            ret.max = max
        }
        return ret;
    }
    public static CreateDateTimeAttribute(attributeId: string, operator: string = QueryOperators.In, value: string = null, min: string = null, max: string = null): AttributeFilterDto {

        let ret: AttributeFilterDto = null;
        if (value || min || max) {
            ret = new AttributeFilterDto();
            ret.attributeId = attributeId;
            ret.operator = operator,
            ret.typeCode = AttributeTypes.DateTime,
            ret.field = AttributeValues.asDateTime,
            ret.value = value,
            ret.min = min,
            ret.max = max
        }
        return ret;
    } 
    public static CreateNumberAttribute(attributeId: string, operator: string = QueryOperators.In, value: string = null, min: string = null, max: string = null): AttributeFilterDto {

        let ret: AttributeFilterDto = null;
        if (value || min || max) {
            ret = new AttributeFilterDto();
            ret.attributeId = attributeId;
            ret.operator = operator,
            ret.typeCode = AttributeTypes.Number,
            ret.field = AttributeValues.asNumber,
            ret.value = value,
            ret.min = min,
            ret.max = max
        }
        return ret;
    }
    public static CreateTimeAttribute(attributeId: string, operator: string = QueryOperators.In, value: string = null, min: string = null, max: string = null): AttributeFilterDto {

        let ret: AttributeFilterDto = null;
        if (value || min || max) {
            ret = new AttributeFilterDto();
            ret.attributeId = attributeId;
            ret.operator = operator,
            ret.typeCode = AttributeTypes.Time,
            ret.field = AttributeValues.asString,
            ret.value = value,
            ret.min = min,
            ret.max = max
        }
        return ret;
    }             
}